const fontSizes = {
  50: 10,
  100: 11,
  200: 12,
  300: 14,
  400: 15,
  500: 16,
  600: 18,
  700: 20,
  800: 24,
  900: 28,
  1000: 32,
};

export { fontSizes };
